module.exports = __webpack_public_path__ + "media/oldman.5913e175.wav";